module.exports = __webpack_public_path__ + "img/lightRing.65d781cf.png";